import * as React from 'react';
import Typography from '@mui/material/Typography';
import Box, { BoxProps } from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import { fontWeight } from '@/theme';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import IconButton from '@mui/material/IconButton';
import Close from '@mui/icons-material/Close';

import { useNavigate } from 'react-router-dom';

type TopBackButtonProps = {
  onClick?: () => void;
  title: string;
  subtitle?: React.ReactNode;
  useBackButton?: boolean;
  rightItem?: React.ReactNode;
  backPath?: string;
  backPathOption?: any;
  boxProps?: BoxProps;
};
export default function TopBackButton({
  onClick,
  title,
  subtitle = '',
  useBackButton = true,
  rightItem,
  backPath = '',
  backPathOption,
  boxProps,
}: TopBackButtonProps) {
  const navigate = useNavigate();
  return (
    <Box position="sticky" top={0} bgcolor="white" zIndex={100} {...boxProps}>
      <Stack direction="row" height="48px" alignItems="center" justifyContent="space-between">
        {useBackButton ? (
          <IconButton
            sx={{
              color: 'text.primary',
              p: 0,
            }}
            onClick={() => {
              // onClick이 있으면 먼저 실행
              if (onClick) {
                onClick();
              }
              if (backPath) {
                navigate(backPath, {
                  state: {
                    ...backPathOption,
                  },
                });
              } else {
                navigate(-1);
              }
            }}
          >
            <ArrowBackIosNewIcon fontSize="medium" />
          </IconButton>
        ) : (
          <Box />
        )}
        <Stack>
          <Typography variant="h5" fontWeight={fontWeight.Bold} textAlign="center">
            {title}
          </Typography>
          {subtitle}
        </Stack>
        {rightItem ? rightItem : <Box width="35px" />}
      </Stack>
    </Box>
  );
}
